module.exports = __webpack_public_path__ + "img/vertical_7_7_7042.fccd4db7.png";